// chatDoctrineGate.js — FASE-12 E1-T05. Decide se a doutrina de CÓDIGO
// (agent-rules books, ~16.8KB) entra no system prompt de um turno.
//
// Num turno CONVERSACIONAL da aba Chat (kind='chat', sem plano proposto e sem DAG
// aprovado) a doutrina é ruído: piora a resposta e estoura o contexto de modelos
// pequenos (visto ao vivo: gemma-4b → "Context size exceeded"). Ela volta assim
// que o turno vira edição de código (planPropose ou dagTasks presentes). Em toda
// sessão de CÓDIGO a doutrina segue como antes. Puro — vive fora do SessionWorkspace
// (que está no teto do ratchet dp-loc).

/**
 * @param {{ kind?: string }} session
 * @param {{ planPropose?: boolean, dagTasks?: unknown, readOnly?: boolean }} turn
 * @returns {boolean} true = injetar a doutrina; false = pular (chat conversacional)
 */
export function shouldInjectCodeDoctrine(session, { planPropose = false, dagTasks = null, readOnly = false } = {}) {
  // FASE-12 E4-T03 — a doutrina guia COMO MUDAR código. Um turno read-only (Ask real,
  // qualquer superfície) NUNCA edita → a doutrina de 16.8KB é puro desperdício de token.
  // (O chat conversacional já era pulado abaixo; planPropose SEGUE injetando — a doutrina
  // molda a qualidade do plano proposto, e o DAG worker de execução recebe via dagTasks.)
  if (readOnly) return false;
  const isChatConversational = session?.kind === 'chat' && !planPropose && !dagTasks;
  return !isChatConversational;
}

/**
 * O bloco de doutrina a injetar — '' quando o gate pula (chat conversacional).
 * Encapsula a decisão INTEIRA para o call-site ficar sem decision points (o
 * SessionWorkspace vive no teto do ratchet dp-loc). `build` é injetado (a
 * buildRulesInjection do renderer) — puro/testável sem o módulo de prefs.
 * @param {{ kind?: string }} session
 * @param {{ planPropose?: boolean, dagTasks?: unknown, readOnly?: boolean }} turn
 * @param {() => { block?: string }} build
 * @returns {string}
 */
export function codeDoctrineBlock(session, turn, build) {
  if (!shouldInjectCodeDoctrine(session, turn)) return '';
  const res = build();
  return (res && res.block) || '';
}
